import React, { useMemo, useState } from 'react';

const hasCookie = (name: string) => document.cookie.split(';').some((c) => c.trim().startsWith(`${name}=`));

const CookieBanner: React.FC = () => {
    const [dismissed, setDismissed] = useState(() => hasCookie('consent'));

    const cookieExpiration = useMemo(() => {
        const date = new Date();
        date.setFullYear(date.getFullYear() + 1);
        return date.toUTCString();
    }, []);

    const registerConsent = (value: 'yes' | 'no') => {
        document.cookie = `consent=${value}; expires=${cookieExpiration}; path=/`;
        setDismissed(true);
    };

    if (dismissed) return null;

    return (
        <div className="cookie-banner">
            <div className="cookie-banner__content">
                <div>
                    <h5>Politique de cookie</h5>
                    <p>Nous utilisons des cookies pour nous assurer de vous offrir la meilleure expérience sur notre site web.</p>
                </div>

                <div className="cookie-banner__actions">
                    <button type="button" className="cookie-banner__button" onClick={() => registerConsent('yes')}>
                        J&apos;accepte
                    </button>
                    <button type="button" className="cookie-banner__button cookie-banner__button--ghost" onClick={() => registerConsent('no')}>
                        Je refuse
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CookieBanner;
